import { render } from "./examples.vue?vue&type=template&id=0b5d1201&scoped=true"
import script from "./examples.vue?vue&type=script&lang=js"
export * from "./examples.vue?vue&type=script&lang=js"

import "./examples.vue?vue&type=style&index=0&id=0b5d1201&scoped=true&lang=css"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5d1201"]])

export default __exports__